export default __webpack_public_path__ + "static/media/Oxleg.684e3477.jpg";